import React, { Component } from "react"
import { getCarParkContentData } from "../../helpers/bookingHelper"
import { decodeHTMLEntities } from "../../../helpers/html"

class ReceiptTextualGuide extends Component {
  state = {
    isActive: true,
  }

  render() {
    if (!this.props.bookingResult) return null

    const { product, carPark } = this.props.bookingResult
    const { content } = this.props
    // const geoLocation = `https://www.google.com/maps/dir/?api=1&destination=${carPark.latitude},${carPark.longitude}&travelmode=driving`
    const carParkContentData = getCarParkContentData(carPark, product, content)
    const headline = carParkContentData && carParkContentData.textualGuide && carParkContentData.textualGuide.headline
    const body = carParkContentData && carParkContentData.textualGuide && carParkContentData.textualGuide.body
    // const geoLocationFromContent = `https://www.google.com/maps/dir/?api=1&destination=${carParkContentData.geoLocation.x},${carParkContentData.geoLocation.y}&travelmode=driving`

    return (
      <section className="deck deck--white deck--padding-bottom">
        <div className="w--wider">
          <article className="article article--slim">
            <div className="rich-text">
              <h4 dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(headline) || "På afrejsedagen" }}></h4>
              <p
                className="bodytext-md"
                dangerouslySetInnerHTML={{
                  __html:
                    decodeHTMLEntities(body) ||
                    "Følg skiltningen til P17. Når du kommer til parkeringsanlægget skal du scanne din QR-kode. QR-koden fungerer som ordrebekræftelse og adgangskort og er det eneste, du behøver have med, når du ankommer. Når du har pakeret bilen, kan du benytte dig af de gratis terminalbusser døgnet rundt. Transporttiden er kun 5-7 minutter til Terminal 2 og 3.",
                }}
              ></p>
              {/* {activeBookingExtraProducts ? <div><h4 dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(carParkContentData.textualGuideHeadline) || "På afrejsedagen TEST FALLBACK" }}></h4>
                <p className="bodytext-md" dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(carParkContentData.textualGuideBody) || "Følg skiltningen til P17. Når du kommer til parkeringsanlægget skal du scanne din QR-kode. QR-koden fungerer som ordrebekræftelse og adgangskort og er det eneste, du behøver have med, når du ankommer. Når du har pakeret bilen, kan du benytte dig af de gratis terminalbusser døgnet rundt. Transporttiden er kun 5-7 minutter til Terminal 2 og 3. TEST FALLBACK" }}>
                </p></div> : <div><h4 dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(carParkContentData.withoutExtra.textualGuideHeadline) || "På afrejsedagen TEST FALLBACK" }}></h4>
                <p className="bodytext-md" dangerouslySetInnerHTML={{ __html: decodeHTMLEntities(carParkContentData.withoutExtra.textualGuideBody) || "Følg skiltningen til P17. Når du kommer til parkeringsanlægget skal du scanne din QR-kode. QR-koden fungerer som ordrebekræftelse og adgangskort og er det eneste, du behøver have med, når du ankommer. Når du har pakeret bilen, kan du benytte dig af de gratis terminalbusser døgnet rundt. Transporttiden er kun 5-7 minutter til Terminal 2 og 3. TEST FALLBACK" }}>
                </p></div>} */}
              {/* <p className="bodytext-md"><a href={geoLocation} target="_blank">{detailsModalTextKeys.wayFinding || "Find vej til"} {product.name} ({carPark.name})</a></p> */}
            </div>
          </article>
        </div>
      </section>
    )
  }
}
export default ReceiptTextualGuide
